import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class SellerReturnWindow extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Seller Return Window
					</div>
					<div>
						<DownloadFile title="Seller Return Window Header" url="ingest/seller-return/window/template"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/seller-return/window"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SellerReturns/Components/SellerReturnWindow.js